import React from 'react';
import '../styles/sections/statistics.scss';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Statistics = (props) => {
    const data = props.data;
    return (
        <div className={`statistics ${data.icons && "with-icons"} col-${data.stats.length}`}>
            <div className="innerBox lg">                
                {data.stats.map((d, i)=>
                    <div key={i} className={`stat col-${data.columns}`}>
                        {d.count && <strong className="zoom-in-out">{d.count}</strong>}
                        {d.icon && <LazyLoadImage effect="blur" src={d.icon} alt="L'OBJET" className="zoom-in-out"/>}                        
                        <p dangerouslySetInnerHTML={{ __html: d.content }} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default Statistics;